import { Dispatch, ReactNode, SetStateAction, createContext, useState } from 'react';

type AuthContextType = {
  userIsLogged: boolean
}

type UserContextProps = {
  state: AuthContextType
  setState: Dispatch<SetStateAction<AuthContextType>>;
}

type AuthProviderProps = {
  children: ReactNode
}

const isLoggedIn = localStorage.getItem('user');

const DEFAULT_VALUE: UserContextProps = {
  state: {
    userIsLogged: isLoggedIn ? true : false,
  },
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setState: () => { }
};

export const AuthContext = createContext<UserContextProps>(DEFAULT_VALUE);

export const AuthProvider = ({ children }: AuthProviderProps) => {
  const [state, setState] = useState(DEFAULT_VALUE.state);

  return (
    <AuthContext.Provider
      value={{
        state,
        setState,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
